import React, { createContext, useEffect, useMemo, useState } from 'react';
import type { Language } from './language';
import { loadLanguage, saveLanguage } from './language';

type I18nContextValue = {
  lang: Language;
  setLang: (lang: Language) => void;
};

export const I18nContext = createContext<I18nContextValue | null>(null);

export const I18nProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [lang, setLang] = useState<Language>(() => loadLanguage());

  useEffect(() => {
    saveLanguage(lang);
  }, [lang]);

  const value = useMemo<I18nContextValue>(() => ({ lang, setLang }), [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

